import { render, staticRenderFns } from "./prodcube.vue?vue&type=template&id=08a16268&scoped=true&"
import script from "./prodcube.vue?vue&type=script&lang=js&"
export * from "./prodcube.vue?vue&type=script&lang=js&"
import style0 from "./prodcube.vue?vue&type=style&index=0&id=08a16268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a16268",
  null
  
)

export default component.exports